import * as React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  CssBaseline,
  Grid,
  Paper,
  Stack,
  Typography,
  Avatar,
  alpha,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CategoryIcon from "@mui/icons-material/Category";
import AppNavbar from "../../../components/AppNavbar";
import Header from "../../../components/Header";
import SideMenu from "../../../components/SideMenu";
import AppTheme from "../../../shared-theme/AppTheme";
import { chartsCustomizations, dataGridCustomizations, datePickersCustomizations, treeViewCustomizations } from "../../dashboard/theme/customizations";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { StyledCellHeader } from "../../../components/StyledCellHeader";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

function currency(n) {
  if (n === undefined || n === null || isNaN(n)) return "RD$0";
  return `RD$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

var columunsVentas = [{"key":"sucursal_nombre","label":"Sucursal"},{"key":"producto_nombre","key2":"id_producto","label":"Producto"},{"key":"cantidad_vendida","label":"Cantidad"},{"key":"precio_unitario_vendido","label":"Precio Unitario"},{"key":"total_venta","label":"Total"},{"key":"creado_por","label":"Cobrado por"}]
var columunsPagosPrestamos = [{"key":"sucursal_nombre","label":"Sucursal"},{"key":"loan_id","label":"Prestamo"},{"key":"cliente","label":"Cliente"},{"key":"monto_pagado","label":"Monto"},{"key":"creado_por","label":"Cobrado por"}]
var columunsInciales = [{"key":"sucursal_nombre","label":"Sucursal"},{"key":"producto_id","label":"Producto"},{"key":"monto","label":"Monto"},{"key":"creado_por","label":"Cobrado por"}]
var columunsGestionCargosPagados = [{"key":"sucursal_nombre","label":"Sucursal"},{"key":"cliente","label":"Cliente"},{"key":"monto","label":"Monto"},{"key":"creado_por","label":"Cobrado por"}]

export default function CuadreDeCajaReport() {
  const navigate = useNavigate();
  const [fecha, setFecha] = React.useState(dayjs());
  const [loading, setLoading] = React.useState(false);
  const [summary, setSummary] = React.useState({
    total_ventas: 0,
    total_ventas_monto: 0,
    total_efectivo: 0,
    total_tarjeta: 0,
    total_transferencia: 0,
    pagos_prestamos: 0,
    iniciales: 0,
    ventas: 0,
    gestion_cargos_pagados: 0,
  });

  const [detailColumns, setDetailColumns] = React.useState([]);
  const [detailRows, setDetailRows] = React.useState([]);
  const [categoriasCargos, setCategoriasCargos] = React.useState([]);
  const [detailTitle, setDetailTitle] = React.useState("");
  const [detailsLoading, setDetailsLoading] = React.useState(false);
  const loadSummary = async () => {
    setLoading(true);
    try {
      const idcompany = localStorage.getItem("idcompany");
      const selectedDate = fecha ? fecha.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/api/pos/daily-summary?idcompany=${idcompany}&fecha=${selectedDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Usuario-ID": localStorage.getItem("id"),
            'X-company-ID': localStorage.getItem('idcompany'),
          },
        }
      );
      const data = await res.json();
      if (data.success) {
        setSummary(data || {});
        setDetailRows(data.ventas || []);
        setDetailColumns(columunsVentas);
        setDetailTitle("Ventas del día");
      }
    } catch (e) {
      console.error("Error loading daily summary", e);
    } finally {
      setLoading(false);
    }
  };
  const fetchCategoriasCargos = async () => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/categorias_cargos/company/${localStorage.getItem('idcompany')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      }
    });

    const data = await response.json();
    setCategoriasCargos(data);
  };

  const handleOpenDetails = async (filter, title) => {
    setDetailTitle(title);
    if(title == "Ventas del día"){
      setDetailColumns(columunsVentas);
      setDetailRows(summary.ventas);
    }else if(title == "Pagos de préstamos del día"){
      setDetailColumns(columunsPagosPrestamos);
      setDetailRows(summary.pagos_prestamos);
    }
    else if(title == "Iniciales del día"){
      setDetailColumns(columunsInciales);
      setDetailRows(summary.iniciales);
    }
    else if(title == "Ventas - "+filter.category){
      setDetailColumns(columunsGestionCargosPagados);
      setDetailRows(summary.gestion_cargos_pagados.filter(item => item.id_cargo == filter.id).map(item=>({...item, cliente: JSON.parse(item.cliente)["nombre"]})));
    }
  };


  React.useEffect(() => {
    loadSummary();
    fetchCategoriasCargos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fecha]);

  const MetricCard = ({ label, value, color = "#18586b", icon, onClick }) => (
    <Card
      sx={{
        background: `linear-gradient(135deg, ${alpha(color, 0.14)}, ${alpha(color, 0.06)})`,
        border: `1px solid ${alpha(color, 0.22)}`,
        borderRadius: 3,
        position: "relative",
        overflow: "hidden",
        transition: "all 0.25s ease",
        cursor: onClick ? 'pointer' : 'default',
        '&:before': {
          content: '""',
          position: 'absolute',
          right: -40,
          top: -40,
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: alpha(color, 0.08),
        },
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: `0 14px 28px ${alpha(color, 0.18)}`,
        }
      }}
      onClick={onClick}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 , fontSize:16}}>
            {label}
          </Typography>
          <Avatar
            sx={{
              bgcolor: alpha(color, 0.12),
              color: color,
              width: 40,
              height: 40,
              border: `2px solid ${alpha(color, 0.2)}`,
            }}
          >
            {icon}
          </Avatar>
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 800, color }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <AppTheme themeComponents={xThemeComponents}>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <SideMenu />
        <AppNavbar />
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header parent={"Gestión Comercial"} child={"Cuadre de Caja"} />
            <Container maxWidth="xl" sx={{ flexGrow: 1, py: 3 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" px={2} mb={2}>
                <Box display="flex" alignItems="center" gap={2}>
                  <Button variant="outlined" startIcon={<ArrowBack/>} onClick={() => navigate(-1)}>Atras</Button>
                  <Typography variant="h4" fontWeight="bold">
                    Cuadre de Caja
                  </Typography>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={fecha}
                    onChange={(v) => setFecha(v)}
                    label="Fecha"
                    slotProps={{
                      textField: { size: "small", sx: { backgroundColor: "white" } },
                    }}
                  />
                </LocalizationProvider>
              </Box>

              {summary.ventas && (
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                  <MetricCard
                    label="Total Ventas"
                    value={currency(summary.ventas.reduce((acc, item) => acc + parseFloat(item.total_venta), 0))}
                    color="#2e7d32"
                    icon={<AttachMoneyIcon />}
                    onClick={() => handleOpenDetails({ type: 'all' }, 'Ventas del día')}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                  <MetricCard
                    label="Total Pagos Préstamos"
                      value={currency(summary.pagos_prestamos.reduce((acc, item) => acc + parseFloat(item.monto_pagado), 0))}
                    color="#1976d2"
                    icon={<ReceiptLongIcon />}
                    onClick={() => handleOpenDetails({ type: 'all' }, 'Pagos de préstamos del día')}
                  />
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                  <MetricCard
                    label="Total Pagos Iniciales"
                    value={currency(summary.iniciales.reduce((acc, item) => acc + parseFloat(item.monto), 0))}
                    color="#6a1b9a"
                    icon={<AccountBalanceWalletIcon />}
                    onClick={() => handleOpenDetails({ type: 'payment', methods: ['efectivo'] }, 'Iniciales del día')}
                  />
                </Grid>

                {categoriasCargos.map((categoria, idx) => (
                  <Grid key={idx} item size={{ xs: 12, sm: 6, md: 3 }}>
                    <MetricCard
                      label={categoria.nombre}
                      value={currency((summary?.gestion_cargos_pagados.filter(item => item.id_cargo == categoria.id).reduce((acc, item) => acc + item.monto, 0)))}
                      color="#18586b"
                      icon={<CategoryIcon />}
                      onClick={() => handleOpenDetails({ type: 'category', category: categoria.nombre, id: categoria.id }, `Ventas - ${categoria.nombre}`)}
                    />
                  </Grid>
                ))}
              </Grid>
              )}

              {detailTitle && (
                <Paper sx={{ p: 3, borderRadius: 3, mt: 2 }}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h6" fontWeight={700}>{detailTitle}</Typography>
                    <Typography variant="body2" color="text.secondary">{fecha.format('DD/MM/YYYY')}</Typography>
                  </Box>
                  {detailsLoading ? (
                    <Typography variant="body2" color="text.secondary">Cargando detalles...</Typography>
                  ) : detailRows.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">Sin resultados</Typography>
                  ) : (
                    <TableContainer component={Paper} >
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            {detailColumns.map((column, idx) => (
                              <StyledCellHeader key={idx}>{column.label}</StyledCellHeader>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {detailRows.map((r, i) => (
                            <TableRow key={i} hover>
                              {detailColumns.map((column, idx) => (   
                                <TableCell key={idx}>{column.key2?r[column.key2]:r[column.key]}</TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Paper>
              )}

            </Container>
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}


